import { render, staticRenderFns } from "./CollectionItemSlide.vue?vue&type=template&id=7aaee43a&lang=pug&"
import script from "./CollectionItemSlide.vue?vue&type=script&lang=js&"
export * from "./CollectionItemSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports